export default "__VITE_PUBLIC_ASSET__f3dd1daa__"